<template>
  <RiseupHeader>
    <img class="hamburger-image" :src="require('@/assets/nav/Hamburger.svg')" v-on:click.stop="openNavBar"/>
  </RiseupHeader>
</template>

<script>

import NavigationBus from '../../event-bus/navigation-bus';
import RiseupHeader from './RiseupHeader.vue';

export default {
  name: 'NavigationHeader',
  components: {
    RiseupHeader,
  },
  methods: {
    openNavBar() {
      NavigationBus.$emit('open');
    },
  },
};
</script>

<style lang="scss" scoped>
.hamburger-image {
  width: 18px;
  height: 16px;
}
</style>
